import React from "react";
import { useTranslation } from "react-i18next";

interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: "terms" | "privacy";
}

const LegalModal: React.FC<LegalModalProps> = ({ isOpen, onClose, title }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
      <div className="bg-white p-6 rounded-xl max-w-lg w-full shadow-xl">
        <h2 className="text-xl font-semibold mb-4">
          {title === "terms" ? t("termsTitle") : t("privacyTitle")}
        </h2>

        <p className="text-sm text-gray-700 whitespace-pre-line h-64 overflow-y-auto">
          {title === "terms" ? t("terms") : t("privacy")}
        </p>

        <div className="mt-4 text-right">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-indigo-600 text-white rounded-lg"
          >
            {t("agree")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
